export enum ModuleEnum {
  search = 'search',
  home = 'home',
  meetings = 'meetings',
  shareholders = 'shareholders',
  communication = 'communication',
  files = 'files',
  signatures = 'signatures',
  tasks = 'tasks',
  chat = 'chat',
  boardschool = 'boardschool',
  surveys = 'surveys',
  academy = 'academy',
  boardmatch_org = 'boardmatch-org',
  organization = 'organization',
  newOrg = 'new-org',
  expertHelp = 'expertHelp',
  boardmatch_candidate = 'boardmatch',
  investments = 'investments',
  templates = 'templates',
  configure = 'configure',
  admin = 'admin',
  client = 'client',
  external = 'external',
}

export const moduleToIcon: { [key in ModuleEnum]: string } = {
  [ModuleEnum.search]: 'search',
  [ModuleEnum.home]: 'home',
  [ModuleEnum.meetings]: 'gavel',
  [ModuleEnum.shareholders]: 'group',
  [ModuleEnum.communication]: 'feedback',
  [ModuleEnum.signatures]: 'border_color',
  [ModuleEnum.files]: 'folder',
  [ModuleEnum.tasks]: 'task',
  [ModuleEnum.chat]: 'chat',
  [ModuleEnum.boardschool]: 'school',
  [ModuleEnum.surveys]: 'inventory',
  [ModuleEnum.academy]: 'school',
  [ModuleEnum.boardmatch_org]: 'join_right',
  [ModuleEnum.organization]: 'domain',
  [ModuleEnum.newOrg]: 'domain_add',
  [ModuleEnum.expertHelp]: 'psychology',
  [ModuleEnum.boardmatch_candidate]: 'join_left',
  [ModuleEnum.investments]: 'monitoring',
  [ModuleEnum.templates]: 'templates',
  [ModuleEnum.configure]: 'settings',
  [ModuleEnum.admin]: 'shield_person',
  [ModuleEnum.client]: 'shield_person',
  [ModuleEnum.external]: 'partner_exchange',
};

export const moduleColors: { [key in ModuleEnum]: string } = {
  [ModuleEnum.signatures]: 'orgbrain-signatures',
  [ModuleEnum.meetings]: 'orgbrain-meetings',
  [ModuleEnum.tasks]: 'orgbrain-tasks',
  [ModuleEnum.communication]: 'orgbrain-communication',
  [ModuleEnum.boardmatch_candidate]: 'orgbrain-boardmatch',
  [ModuleEnum.boardmatch_org]: 'orgbrain-boardmatch',
  [ModuleEnum.investments]: 'orgbrain-investments',
  [ModuleEnum.files]: 'orgbrain-files',
  [ModuleEnum.surveys]: 'orgbrain-surveys',
  [ModuleEnum.organization]: 'orgbrain-organization',
  [ModuleEnum.boardschool]: 'orgbrain-boardschool',

  [ModuleEnum.search]: 'orgbrain-gray',
  [ModuleEnum.home]: 'orgbrain-gray',
  [ModuleEnum.shareholders]: 'orgbrain-gray',
  [ModuleEnum.chat]: 'orgbrain-gray',
  [ModuleEnum.academy]: 'orgbrain-gray',
  [ModuleEnum.newOrg]: 'orgbrain-gray',
  [ModuleEnum.expertHelp]: 'orgbrain-gray',
  [ModuleEnum.templates]: 'orgbrain-gray',
  [ModuleEnum.configure]: 'orgbrain-gray',
  [ModuleEnum.admin]: 'orgbrain-gray',
  [ModuleEnum.client]: 'orgbrain-gray',
  [ModuleEnum.external]: 'orgbrain-gray',
};
